var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBadgesPathwayBackgroundRightB10 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    viewBox: "0 0 1145.22 2039.71",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;fill-rule:evenodd;opacity:.31;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.34,0h165.88c.27,.24,0,2039.71,0,2039.71,0,0-124.57,.77-122-.3,21.73-9.12,76.32-128.77,19-193.42-98.6-111.21-59.63-252.39,5.87-363.07,93.57-158.1,115.2-444.99,40.47-629.4-38.53-95.09-152.25-220.23-182.34-283.06-46.83-97.77-29.96-241.75,95-337.7,124.96-95.95,13.82-204.95-21.88-232.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadgesPathwayBackgroundRightB10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BadgesPathwayBackground_RightB10.9203dc91.svg";
export { ForwardRef as ReactComponent };